import React from 'react';
import styles from './ProProfileHeader.module.scss';

import ReviewStarBar from '@z-components/molecules/ReviewStarBar/ReviewStarBar';
import StarRating from '@z-components/atoms/StarRating';

const STAR_VALUE = 5;

interface Props {
  feedbackCountsByRating: {
    rate1: number;
    rate2: number;
    rate3: number;
    rate4: number;
    rate5: number;
    totalRate: number;
  };
  isDesktop?: boolean;
  rating: number;
  reviewCount: number;
  displayTitle?: boolean;
}

const TRANSLATIONS = {
  en: {
    reviewCases: 'review cases',
    reviewText: 'review text',
    totalReview: 'total reviews',
  },
  ja: {
    reviewCases: '件のクチコミ',
    reviewText: 'クチコミ',
    totalReview: '総合評価',
  },
};

const ProProfileHeaderReview = ({
  rating,
  reviewCount,
  feedbackCountsByRating,
  isDesktop = false,
  displayTitle = true,
}: Props) => (
  <div>
    {isDesktop ? (
      <div className={styles['review-text-desktop-container']}>
        <div className={styles['review-text-desktop']}>{TRANSLATIONS.ja.reviewText}</div>
      </div>
    ) : (
      displayTitle && <div className={styles['review-text']}>{TRANSLATIONS.ja.reviewText}</div>
    )}

    <div className={styles['review-container']}>
      <div className={styles['bar-review-container']}>
        {Array(STAR_VALUE)
          .fill('')
          .map((_, index) => (
            <ReviewStarBar
              key={`ReviewStarBar-${STAR_VALUE - index}`}
              feedbackCount={
                feedbackCountsByRating[
                  `rate${STAR_VALUE - index}` as 'rate1' | 'rate2' | 'rate3' | 'rate4' | 'rate5'
                ]
              }
              totalFeedbackCount={feedbackCountsByRating['totalRate']}
              starNumber={STAR_VALUE - index}
            />
          ))}
      </div>
      <div className={styles['vertical-border']}></div>
      <div className={styles['total-review-container']}>
        <div className={styles['total-review-text']}>{TRANSLATIONS.ja.totalReview}</div>

        <div className={styles['total-review']}>{rating.toFixed(1)}</div>
        <StarRating rating={Number(rating.toFixed(1))} height={12} />
        <div
          className={styles['review']}
          onClick={scrollToReview}
          onKeyDown={scrollToReview}
          tabIndex={0}
          role="button"
        >
          {`${reviewCount}${TRANSLATIONS.ja.reviewCases}`}
        </div>
      </div>
    </div>
  </div>
);

export default ProProfileHeaderReview;

function scrollToReview() {
  const reviewTag = document.getElementById('review');
  if (!reviewTag) {
    return;
  }

  return reviewTag.scrollIntoView({ behavior: 'smooth' });
}
